<template>
  <li class="collection-skeleton-item">
    <div class="collection-skeleton-card">
      <!-- Thumbnail -->
      <div class="collection-skeleton__thumbnail">
        <div class="collection-skeleton__badge"></div>
      </div>

      <!-- Body -->
      <div class="collection-skeleton__body">
        <div class="collection-skeleton__title"></div>
        <div class="collection-skeleton__meta"></div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "CollectionCardSkeleton"
};
</script>

<style scoped>
.collection-skeleton-item {
  list-style: none;
  padding: 0;
  margin: 0;
}

.collection-skeleton-card {
  background: #ffffff;
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Thumbnail */
.collection-skeleton__thumbnail {
  position: relative;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.collection-skeleton__badge {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 80px;
  height: 24px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 6px;
}

/* Body */
.collection-skeleton__body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.collection-skeleton__title {
  width: 85%;
  height: 18px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.collection-skeleton__meta {
  width: 50%;
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Responsive */
@media (max-width: 959px) {
  .collection-skeleton__body {
    padding: 14px;
  }

  .collection-skeleton__title {
    height: 16px;
  }

  .collection-skeleton__meta {
    height: 12px;
  }
}

@media (max-width: 639px) {
  .collection-skeleton-card {
    border-radius: 14px;
  }

  .collection-skeleton__body {
    padding: 12px;
  }

  .collection-skeleton__badge {
    width: 60px;
    height: 20px;
    top: 8px;
    left: 8px;
  }
}
</style>
